import * as z from "zod"
import { ShipmentFormPayment } from "@prisma/client"

export const ShipmentFormModel = z.object({
  id: z.number().int(),
  created_at: z.date(),
  updated_at: z.date(),
  shipper_contact_id: z.number().int().nullish(),
  consignee_contact_id: z.number().int().nullish(),
  notify_contact_id: z.number().int().nullish(),
  itn_number: z.string().nullish(),
  handling_instructions: z.string().nullish(),
  payment: z.nativeEnum(ShipmentFormPayment),
  accounting_info: z.string().nullish(),
  target_rate: z.number().int().nullish(),
  nature_of_goods: z.string().nullish(),
  hs_code: z.string().nullish(),
  integration_id: z.string().nullish(),
  integration_version: z.number().int().nullish(),
  integration_should_sync: z.boolean().nullish(),
  quote_id: z.number().int(),
  request_id: z.number().int(),
  parent_shipment_form_id: z.number().int().nullish(),
})
